import { useField } from 'react-final-form';

export const typeToIndex: Record<string, number> = {
  driver_front_tire: 0,
  driver_rear_tire: 3,
  passenger_rear_tire: 6,
  passenger_front_tire: 8
};

export const useTiresGrade = (sectionId: string) => {
  const [level1, _0, level2, _1, level3] = sectionId.split('.');
  const imageIndex = typeToIndex[level3];
  const { input: imageGradeInput } = useField(`${level1}.subsections.${level2}.images.${imageIndex}.grade`);
  const { input: aiImageGradeInput } = useField(`${level1}.subsections.${level2}.images.${imageIndex}.ai_grade`);
  const { input: sectionInput } = useField(`${sectionId}.grade`);

  const changeGradeBasedOnNumber = (num: number) => {
    imageGradeInput.onChange(num);
    if (num <= 2) {
      return sectionInput.onChange('poor');
    }
    if (num === 3) {
      return sectionInput.onChange('fair');
    }

    return sectionInput.onChange('good');
  };

  const hasError = (() => {
    if (imageGradeInput.value == null) return true
    if (typeof aiImageGradeInput.value !== 'number') return false
    return imageGradeInput.value !== aiImageGradeInput.value
  })()
  console.log(imageGradeInput.value, aiImageGradeInput.value, hasError, 'hasError');
  return { changeGradeBasedOnNumber, value: imageGradeInput.value, aiValue: aiImageGradeInput.value, hasError, imageIndex };
};
